import CommonError from './error'
import CommonUser from './user'

import { LAYOUT_COMMON_ERROR_ROOT, LAYOUT_COMMON_USER_ROOT } from './navigation'

const routes = [
  {
    path: LAYOUT_COMMON_USER_ROOT,
    component: CommonUser,
    allowToOneOf: ['ROLE_TYPE_MANAGER', 'ROLE_TYPE_VENDOR']
  },
  {
    path: LAYOUT_COMMON_ERROR_ROOT,
    component: CommonError,
    allowToOneOf: ['ROLE_TYPE_MANAGER', 'ROLE_TYPE_VENDOR']
  }
]

export default routes
